import API_URLS from "../../config/BackendConfig";
import { getAuthToken } from "../../utils/tokenUtils";
import { postRequest } from "../../config/AxiosConfig";

// Add Product News
export const AddProductNews = async ({
  news,
  news_date,
  available_product_id,
}) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: API_URLS.ADMIN + "product-news/create",
      data: {
        news,
        news_date,
        available_product_id,
      },
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log(response);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
// ENd

// Retrive ProductNews
export const RetrieveProductNews = async (page = 1) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}product-news/report?page=${page}`,
      headers: { Authorization: `Bearer ${token}` },
    });
  //  console.log(response);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
// ENd

// Edit ProductNews
export const editProductNews = async ({ product_news_id }) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: API_URLS.ADMIN + "product-news/edit",
      data: { product_news_id },
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log(response);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Update ProductNews
export const updateProductNews = async ({ payload, product_news_id }) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}product-news/update`,
      data: { product_news_id, ...payload },
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log(response);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
